module.exports = __webpack_public_path__ + "img/22.91d81df7.svg";